// extracted by mini-css-extract-plugin
export var avatarContainer = "_4x-1";
export var largeAvatarContainer = "_4x-2";
export var smallAvatarContainer = "_4x-0";